<dx-popup
    #vendorAccountEditorPopup
    minWidth="150px"
    minHeight="150px"
    width="75%"
    [height]="popupHeight"
    [title]="title"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onVendorAccountEditorPopupShown()"
    (onHidden)="onAddEditAccountClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box
            *ngIf="vendorAccountRaw"
            #vendorConfigBox
            width="100%"
            height="100%"
            direction="col"
            class="vendor-account-config-box-container"
        >
            <dxi-item [ratio]="1">
                <dx-form #vendorAddEditForm width="100%" height="100%" [scrollingEnabled]="true">
                    <dxi-item>
                        <div *dxTemplate>
                            <dx-toolbar width="100%" height="100%">
                                <dxi-item location="before">
                                    <div *dxTemplate class="flex-row vendor-title">
                                        <strong class="margin-right-5px">Vendor:</strong>
                                        {{ vendorName }}
                                    </div>
                                </dxi-item>
                                <dxi-item location="after">
                                    <ng-container *ngIf="configMode === 'edit'">
                                        <ng-container *ngIf="vendorAccountRaw.hasNotes">
                                            <i
                                                title="Vendor Account Notes"
                                                class="margin-right-5px cc-2x icon-content dx-theme-accent-as-text-color cursor-pointer"
                                                [ngClass]="iconNotes"
                                                (click)="onNotesClick()"
                                            ></i>
                                        </ng-container>
                                        <ng-container *ngIf="!vendorAccountRaw.hasNotes">
                                            <i
                                                title="Vendor Notes"
                                                class="cc-2x icon-content dx-theme-accent-as-text-color cursor-pointer"
                                                [ngClass]="iconEmptyNotes"
                                                (click)="onNotesClick()"
                                            ></i>
                                        </ng-container>
                                    </ng-container>
                                </dxi-item>
                                <dxi-item></dxi-item>
                            </dx-toolbar>
                        </div>
                    </dxi-item>

                    <dxi-item itemType="group" caption="General Information">
                        <dxi-item itemType="group" [colCount]="2">
                            <dxi-item [isRequired]="true">
                                <dxo-label text="Account Number"></dxo-label>
                                <div *dxTemplate>
                                    <dx-text-box
                                        #accountNumber
                                        [maxLength]="50"
                                        [(value)]="vendorAccountRaw.accountNumber"
                                    >
                                        <dx-validator>
                                            <dxi-validation-rule
                                                type="required"
                                                message="Account Number is required"
                                            ></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </dxi-item>
                            <dxi-item>
                                <dxo-label text="Account Is Active"></dxo-label>
                                <div *dxTemplate>
                                    <dx-switch
                                        switchedOnText="Yes"
                                        switchedOffText="No"
                                        [width]="50"
                                        [(value)]="vendorAccountRaw.active"
                                    ></dx-switch>
                                </div>
                            </dxi-item>
                        </dxi-item>

                        <dxi-item itemType="group" [colCount]="2">
                            <dxi-item [isRequired]="true">
                                <dxo-label text="Account Description"></dxo-label>
                                <div *dxTemplate>
                                    <dx-text-box
                                        #accountDescription
                                        [maxLength]="200"
                                        [(value)]="vendorAccountRaw.description"
                                    ></dx-text-box>
                                </div>
                            </dxi-item>

                            <dxi-item>
                                <dxo-label text="Authorized Users"></dxo-label>
                                <div *dxTemplate>
                                    <dx-text-box
                                        #authorisedUser
                                        [maxLength]="200"
                                        [(value)]="vendorAccountRaw.authorizedUsers"
                                    ></dx-text-box>
                                </div>
                            </dxi-item>
                        </dxi-item>
                    </dxi-item>

                    <dxi-item *ngIf="vendorAccountRaw?.isEFTOffered" itemType="group" caption="EFT Information">
                        <dxi-item itemType="group" [colCount]="5">
                            <dxi-item>
                                <dxo-label text="Is Active"></dxo-label>
                                <div *dxTemplate>
                                    <dx-switch
                                        switchedOnText="Yes"
                                        switchedOffText="No"
                                        [width]="50"
                                        [(value)]="vendorAccountRaw.eftActive"
                                        (onValueChanged)="onEFTActiveStateChanged()"
                                    ></dx-switch>
                                </div>
                            </dxi-item>

                            <dxi-item [colSpan]="2">
                                <dxo-label text="Inactive Reason"></dxo-label>
                                <div *dxTemplate>
                                    <dx-select-box
                                        valueExpr="key"
                                        displayExpr="displayText"
                                        [disabled]="vendorAccountRaw.eftActive"
                                        [searchEnabled]="true"
                                        [showClearButton]="true"
                                        [dataSource]="vendorAccountEditor.eftInactiveReasons"
                                        [(value)]="vendorAccountRaw.eftInactiveReason"
                                    ></dx-select-box>
                                </div>
                            </dxi-item>

                            <dxi-item [colSpan]="2" [isRequired]="vendorAccountRaw.eftActive">
                                <dxo-label text="Bank Account"></dxo-label>
                                <div *dxTemplate>
                                    <app-multi-column-selector
                                        #bankAccountSelector
                                        [disabled]="!vendorAccountRaw.eftActive"
                                        [name]="'Bank Account'"
                                        [gridSource]="vendorAccountBankAccounts"
                                        [boxValue]="bankAccountsBoxValue"
                                        [valueExpr]="'bankAccountId'"
                                        [displayExpr]="'bankName'"
                                        [columnDef]="bankAccountColumns"
                                        [dropDownButtonTemplate]="'dropDownButton'"
                                        [dropDownOptions]="{ width: 'auto' }"
                                        [showClearButton]="true"
                                        [cssClass]="'drop-down-box'"
                                        [placeholder]="'Banking...'"
                                        (gridSelectionEvent)="onBankAccountSelection($event)"
                                    ></app-multi-column-selector>
                                </div>
                            </dxi-item>
                        </dxi-item>

                        <dxi-item>
                            <dxo-label text="Website"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-box
                                    #eftWebsite
                                    [disabled]="!vendorAccountRaw.eftActive"
                                    [maxLength]="200"
                                    [(value)]="vendorAccountRaw.eftWebsite"
                                ></dx-text-box>
                            </div>
                        </dxi-item>

                        <dxi-item itemType="group" [colCount]="3">
                            <dxi-item>
                                <dxo-label text="User Name"></dxo-label>
                                <div *dxTemplate>
                                    <dx-text-box
                                        #eftUsername
                                        [disabled]="!vendorAccountRaw.eftActive"
                                        [maxLength]="100"
                                        [(value)]="vendorAccountRaw.eftUserName"
                                    ></dx-text-box>
                                </div>
                            </dxi-item>

                            <dxi-item>
                                <dxo-label text="Password"></dxo-label>
                                <div *dxTemplate>
                                    <dx-text-box
                                        #eftPassword
                                        [disabled]="!vendorAccountRaw.eftActive"
                                        mode="password"
                                        [maxLength]="50"
                                        [(value)]="vendorAccountRaw.eftPassword"
                                    ></dx-text-box>
                                </div>
                            </dxi-item>

                            <dxi-item>
                                <div *dxTemplate class="flex-row padding-top-5px">
                                    <span>EFT Forms:</span>
                                    <i
                                        title="Forms"
                                        class="margin-left-5px cursor-pointer cc-1-25x fas fa-paperclip"
                                        (click)="onEFTFormClick()"
                                    ></i>
                                    <span
                                        class="cc-text-bold margin-left-3px cursor-pointer"
                                        *ngIf="vendorAccountEditor?.eftForms?.length > 0"
                                    >
                                        ({{ vendorAccountEditor?.eftForms?.length }})
                                    </span>
                                </div>
                            </dxi-item>
                        </dxi-item>
                    </dxi-item>

                    <dxi-item itemType="group" [colCount]="3" caption="Late Fee Processing Information">
                        <dxi-item>
                            <dxo-label text="Agree To Vendor Terms"></dxo-label>
                            <div *dxTemplate>
                                <dx-switch
                                    switchedOnText="Yes"
                                    switchedOffText="No"
                                    [width]="50"
                                    [(value)]="vendorAccountRaw.agreeToVendorTerms"
                                ></dx-switch>
                            </div>
                        </dxi-item>

                        <dxi-item>
                            <dxo-label text="Charges Late Fee / Finance Charge"></dxo-label>
                            <div *dxTemplate>
                                <dx-switch
                                    switchedOnText="Yes"
                                    switchedOffText="No"
                                    [width]="50"
                                    [(value)]="vendorAccountRaw.chargesLateFeeOrFinanceCharge"
                                ></dx-switch>
                            </div>
                        </dxi-item>

                        <dxi-item>
                            <dxo-label text="Will Terminate / Disconnect"></dxo-label>
                            <div *dxTemplate>
                                <dx-switch
                                    switchedOnText="Yes"
                                    switchedOffText="No"
                                    [width]="50"
                                    [(value)]="vendorAccountRaw.willTerminateOrDisconnect"
                                ></dx-switch>
                            </div>
                        </dxi-item>
                    </dxi-item>

                    <dxi-item itemType="group" [colCount]="2" caption="Billing Cycle Information">
                        <dxi-item [isRequired]="true">
                            <dxo-label text="Frequency"></dxo-label>
                            <div *dxTemplate>
                                <dx-select-box
                                    valueExpr="key"
                                    displayExpr="displayText"
                                    [searchEnabled]="true"
                                    [(value)]="vendorAccountRaw.billingFrequency"
                                    [dataSource]="vendorAccountEditor.billingFrequencies"
                                    (onValueChanged)="onBillingFrequencyChange()"
                                ></dx-select-box>
                            </div>
                        </dxi-item>

                        <dxi-item>
                            <dxo-label text="Value"></dxo-label>
                            <div *dxTemplate>
                                <ng-container *ngIf="!enableDateBilling">
                                    <dx-text-box
                                        #eftBillingTextValue
                                        [maxLength]="50"
                                        [(value)]="vendorAccountRaw.billingFrequencyValue"
                                    ></dx-text-box>
                                </ng-container>
                                <ng-container *ngIf="enableDateBilling">
                                    <dx-date-box
                                        #eftDateBillingValue
                                        type="date"
                                        openOnFieldClick="true"
                                        [showClearButton]="true"
                                        [useMaskBehavior]="true"
                                        [(value)]="billingDateValue"
                                        (onValueChanged)="onBillingValueDateChanged()"
                                    ></dx-date-box>
                                </ng-container>
                            </div>
                        </dxi-item>
                    </dxi-item>

                    <dxi-item itemType="group" [colCount]="2" caption="Account Billing Status">
                        <dxi-item [colSpan]="2">
                            <dxo-label text="Account Billing Status"></dxo-label>
                            <div *dxTemplate>
                                <dx-select-box
                                    valueExpr="key"
                                    displayExpr="displayText"
                                    [elementAttr]="{ class: 'select-box' }"
                                    [searchEnabled]="true"
                                    [(value)]="vendorAccountRaw.accountBillingStatus"
                                    [dataSource]="vendorAccountEditor.accountBillingStatuses"
                                ></dx-select-box>
                            </div>
                        </dxi-item>

                        <dxi-item *ngIf="configMode !== 'add'">
                            <dxo-label text="Status Last Updated"></dxo-label>
                            <div *dxTemplate>
                                <span>{{ vendorAccountStatusUpdatedAt }}</span>
                            </div>
                        </dxi-item>

                        <dxi-item *ngIf="configMode !== 'add'">
                            <dxo-label text="Status Last Updated By"></dxo-label>
                            <div *dxTemplate>
                                <span>{{ vendorAccountRaw?.statusLastUpdatedBy?.displayName }}</span>
                            </div>
                        </dxi-item>
                    </dxi-item>
                </dx-form>
            </dxi-item>

            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Cancel"
                                    hint="Cancel"
                                    [icon]="iconTimes"
                                    (onClick)="onCancelVendorAccountConfiguration()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Save"
                                    hint="Save"
                                    [icon]="iconSave"
                                    (onClick)="onSaveVendorAccountConfiguration()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-popup
    #manageDocumentsPopup
    minWidth="150px"
    minHeight="150px"
    width="40%"
    height="40%"
    title="Manage Documents"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="showManageDocuments"
    (onHidden)="onManageDocumentsClose()"
>
    <div *dxTemplate="let data of 'content'">
        <div class="manage-documents">
            <dx-data-grid
                [dataSource]="vendorAccountEditor.eftForms"
                [showBorders]="true"
                [showColumnLines]="true"
                [showRowLines]="true"
                [hoverStateEnabled]="true"
                [columnAutoWidth]="true"
            >
                <dxo-selection mode="single"></dxo-selection>

                <dxo-editing [useIcons]="true"></dxo-editing>

                <dxi-column caption="File" cellTemplate="invoiceFileCellTemplate"></dxi-column>

                <dxi-column caption="Name" dataField="fileName"></dxi-column>

                <div *dxTemplate="let row of 'invoiceFileCellTemplate'">
                    <i
                        class="cc-1-5x cc-icon-pdf cc-hyperlink"
                        [ngClass]="iconPdf"
                        (click)="onDownloadFile(row.data)"
                    ></i>
                </div>
            </dx-data-grid>
        </div>
    </div>
</dx-popup>

<app-vendor-account-notes
    #vendorAccountEditorNotes
    *ngIf="showNotesPopUp"
    id="vendorAccountEditorNotes"
    [communityId]="communityId"
    [hasNotes]="vendorAccountRaw?.hasNotes"
    [associationVendorId]="associationVendorId"
    [vendorAccountId]="vendorAccount.id"
    [accountNumber]="vendorAccount.accountNumber"
    (vendorAccountNotesClose)="onVendorAccountNotesClose($event)"
></app-vendor-account-notes>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#vendorConfigBox' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<cc-message-box #vendorAccountMessageBox></cc-message-box>
